import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState, useEffect } from "react";
import { MetaNavigationMobile } from "../../metanavigation";
import { Tabs } from "../../tabs";
import { TabsWrapper, StyledMenuBar } from "./Navigation.styles";
import { getItems, getCurrentPath, isMenuItemActive, findNavHistoryForPath, } from "./utils";
import { CurrentSelected } from "./CurrentSelected";
import { NavHistory } from "./NavHistory";
export function MenuBar({ items, onChange, metaNavigationProps, isDrawerOpen, containerHeight, router, homeLabel, backLabel, }) {
    const initialHistory = { level: 0, tabIndex: 0, title: "" };
    const [navHistory, setNavHistory] = useState([
        initialHistory,
    ]);
    const [menuItems, setMenuItems] = useState(items);
    useEffect(() => {
        const initialNavHistory = findNavHistoryForPath(items, getCurrentPath(router));
        if (initialNavHistory.length > 1) {
            setNavHistory(initialNavHistory);
            const menuItems = getItems(items, initialNavHistory);
            setMenuItems(menuItems);
        }
    }, [items]);
    function handleHistoryChange(history) {
        const newItems = getItems(items, history);
        if (newItems.length > 0) {
            setMenuItems(newItems);
            setNavHistory(history);
        }
        if (history.length < 1) {
            setNavHistory([
                {
                    level: 0,
                    tabIndex: 0,
                    title: "",
                },
            ]);
        }
    }
    function handleOnchange(selected) {
        const newHistory = [
            ...navHistory,
            {
                level: navHistory.length,
                tabIndex: selected.index,
                title: selected.title,
            },
        ];
        handleHistoryChange(newHistory);
        if (onChange) {
            onChange(Object.assign(Object.assign({}, selected), { level: navHistory.length, leaf: !menuItems[selected.index].items }));
        }
    }
    const currentPath = getCurrentPath(router);
    const memoisedMenuItems = useMemo(() => {
        return menuItems.map((item) => {
            var _a, _b;
            const isActive = isMenuItemActive(item, currentPath);
            return Object.assign(Object.assign({}, item), { isActive, withoutIcon: (_a = item.withoutIcon) !== null && _a !== void 0 ? _a : !((_b = item.items) === null || _b === void 0 ? void 0 : _b.length) });
        });
    }, [menuItems, currentPath]);
    return (_jsxs(StyledMenuBar, Object.assign({ className: "menu-bar", containerHeight: containerHeight, isDrawerOpen: isDrawerOpen }, { children: [_jsxs("div", Object.assign({ style: { paddingTop: "1rem" } }, { children: [_jsx(NavHistory, { onChange: ({ level: l }) => {
                            const his = [...navHistory].splice(0, l);
                            handleHistoryChange(his);
                            let last = [...his].pop();
                            if (!last) {
                                last = {
                                    level: 0,
                                    tabIndex: 0,
                                    title: "",
                                };
                            }
                            if (typeof onChange === "function") {
                                onChange({
                                    index: last === null || last === void 0 ? void 0 : last.tabIndex,
                                    level: last === null || last === void 0 ? void 0 : last.level,
                                    title: last === null || last === void 0 ? void 0 : last.title,
                                });
                            }
                        }, onBack: () => {
                            const copy = [...navHistory];
                            copy.splice(-1, 1);
                            handleHistoryChange(copy);
                            let last = [...copy].pop();
                            if (!last) {
                                last = {
                                    level: 0,
                                    tabIndex: 0,
                                    title: "",
                                };
                            }
                            if (typeof onChange === "function") {
                                onChange({
                                    index: last === null || last === void 0 ? void 0 : last.tabIndex,
                                    level: last === null || last === void 0 ? void 0 : last.level,
                                    title: last === null || last === void 0 ? void 0 : last.title,
                                });
                            }
                        }, navHistory: navHistory, homeLabel: homeLabel, backLabel: backLabel }), navHistory.length > 1 && (_jsx(CurrentSelected, { title: navHistory[navHistory.length - 1].title })), _jsx(TabsWrapper, { children: _jsx(Tabs, { usedForNavigation: true, initialSelected: -1, alignment: "vertical", items: memoisedMenuItems.map((item) => (Object.assign(Object.assign({}, item), { onClick: (event) => {
                                    var _a;
                                    if (typeof item.onClick === "function") {
                                        item.onClick(event, !!((_a = item.items) === null || _a === void 0 ? void 0 : _a.length));
                                    }
                                } }))), onTabChange: (selected) => handleOnchange(selected) }) })] })), isDrawerOpen && (_jsx(MetaNavigationMobile, Object.assign({}, metaNavigationProps, { onChange: (selected) => {
                    onChange(selected);
                    handleHistoryChange([initialHistory]);
                } })))] })));
}
